import ButtonComponent from '../../../Buttons/ButtonComponent';
import BrokersPricingCard from './BrokersPricingCard';

import Styles from '../styles.module.scss';

const BrokersPricingSection = (props) => (
  <div className={Styles['brokers-pricing-section']}>
    <div className={Styles.section}>
      <h2>API Data Should Not Cost a Fortune</h2>
      <p>Automation lowers costs and delivers reliable, high-quality data</p>
      <BrokersPricingCard
        goToContactForm={props.goToContactForm}
      />
      <span className={Styles.note}>
        *All plans are cumulative and contain all features of lower tiers
      </span>
      <ButtonComponent
        withoutReload
        value="See All Pricing Plans"
        path="/products/api/financial-news/pricing-api/commercial"
        green
      />
    </div>
  </div>
);

export default BrokersPricingSection;
